// PhoneNumberInput.js
import React from 'react';
import { PatternFormat } from 'react-number-format';

const PhoneNumberInput = ({ value, onChange, placeholder, name }) => {
  return (
    <PatternFormat
      format="###-###-####" 
      mask="_"
      value={value || ''}
      onValueChange={(values) => {
        onChange(values.formattedValue); 
      }}
      placeholder={placeholder || "___-___-____"}
      name={name}
      type="tel"
    />
  );
};

export default PhoneNumberInput;